import React from 'react'

export default function AddProgress() {
    return (
        <div>AddProgress</div>
    )
}
